import * as React from 'react';
import { type ChangeEvent, forwardRef } from "react";
import { clsx } from 'clsx';
import { isFunction } from "../helpers/utils";

type Props = Readonly<React.ComponentPropsWithRef<"input"> & {
	label?: string,
	onChangeBoolean?: (checked: boolean) => void
}>;

const Checkbox = forwardRef<HTMLInputElement, Props>((
	{
		label = '',
		className = '',
		name,
		checked = false,
		onChange,
		onChangeBoolean,
		...otherProps
	}: Props,
	ref
) => {
	function toggleCheckboxChange(e: ChangeEvent<HTMLInputElement>) {
		if (isFunction(onChangeBoolean)) {
			onChangeBoolean(!checked);
		}

		if (isFunction(onChange)) {
			onChange(e);
		}
	}

	return (
		<label htmlFor={name} className="mr-2">
			<input
				className={clsx(className, label && 'mr-2')}
				type="checkbox"
				value={name}
				checked={checked}
				ref={ref}
				{...otherProps}
				onChange={toggleCheckboxChange}
			/>
			{label && <span>{label}</span>}
		</label>
	);
});

export default Checkbox;
